import React, { useState } from "react";
import {
  MagnifyingGlassIcon,
} from "@heroicons/react/20/solid";
import { useNavigate } from "react-router-dom";


const SearchBox = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  const handleSearch = () => {
    navigate(`/dashboard/orderdetail?id=${searchTerm}`, { state: { login: true } });
  };

  return (
    <div className="flex items-center space-x-4">
      {/* Search Box */}
      <input
        type="text"
        value={searchTerm}
        name="search"
        onChange={(e) => setSearchTerm(e.target.value)}
        placeholder="Invoice"
        className="py-2 px-4 border border-gray-300 rounded-md focus:outline-none focus:ring focus:border-indigo-400"
      />

      <div
        onClick={() => handleSearch()}
        className="cursor-pointer inline-flex justify-center items-center rounded-md bg-indigo-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:text-white"
      >
        Search Order
        <MagnifyingGlassIcon
          className="h-5 w-5 ml-2 text-white"
          aria-hidden="true"
        />
      </div>
    </div>
  );
};

export default SearchBox;
